import clsx from 'clsx';
import { Modal as ErpModal } from 'components/UI/Modal/extend';
import React from 'react';

import s from './Modal.module.less';

type ErpModalProps = React.ComponentProps<typeof ErpModal>;

export interface ModalProps extends ErpModalProps {
  // All five prop-driven style branches are now handled via conditional classes
  // (.fullHeight/.billing/.fullPage/.warning/.noFooterBorder). They stay on the
  // public type so the 122 styled consumers + 17 barrel consumers + 11+
  // cross-file styled(UIModal) wrappers compile unchanged (MIG-05).
  isBilling?: boolean;
  isFullPage?: boolean;
  isFullHeight?: boolean;
  isWarning?: boolean;
  borderedFooterBorder?: boolean;
}

export const Modal: React.FC<ModalProps> = (props) => {
  // The five prop-driven styling props drive conditional classes. They are
  // destructured out of `rest` so they are NOT spread onto ErpModal/AntdModal
  // (they were emotion styling props, not DOM attributes). All five remain on
  // the public ModalProps type (MIG-05).
  const { isBilling, isFullPage, isWarning, borderedFooterBorder, isFullHeight, className, style, ...rest } = props;

  // Forward BOTH className AND style: cross-file styled(UIModal)/styled(Modal)
  // emotion wrappers inject their generated class via `className`, and direct
  // consumers pass inline `style` (Pitfall 5, MIG-05). The class lands on the
  // .ant-modal root, where the :global descendant overrides resolve.
  // `borderedFooterBorder` is INVERTED (Pitfall 3): the footer border is REMOVED
  // when the prop is falsy; a truthy value keeps the Ant default border.
  return (
    <ErpModal
      {...rest}
      className={clsx(
        s.root,
        {
          [s.fullHeight]: isFullHeight,
          [s.billing]: isBilling,
          [s.fullPage]: isFullPage,
          [s.warning]: isWarning,
          [s.noFooterBorder]: !borderedFooterBorder,
        },
        className,
      )}
      style={style}
    />
  );
};

export const ModalTitle: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <div {...rest} className={clsx(s.modalTitle, className)}>
      {children}
    </div>
  );
};
